import React, { useMemo } from 'react';
import { Card, List, Typography } from 'antd';
import styles from './NewsTicker.module.css';
import { useSessionData, useIsSessionLoading } from '../../../../hooks/useSessionData';
import type { EventItem } from '../../../../types/types';
const { Text } = Typography;

const NewsTicker: React.FC = () => {
  const isLoading = useIsSessionLoading();
  const currentEvents = useSessionData(session => session.roster.currentEvents, []);

  const augmentedEvents = useMemo(() => ((currentEvents || []) ?? []).map(event => ({
    ...event,
    name: event.text, // Create a synthetic 'name' property for DataPanel sorting
  })), [currentEvents]);

  if (isLoading) {
    return <Card title="News & Events" size="small" loading />;
  }

  return (
    <Card
      title="News & Events"
      size="small"
      className={styles.card}
    >
      <div>
        <List
          dataSource={augmentedEvents}
          renderItem={(event: EventItem) => (
            <List.Item className={styles.item}>
              <Text>• {event.text}</Text>
            </List.Item>
          )}
        />
      </div>
    </Card>
  );
};

export default NewsTicker;